import React from "react";
import { useGetNotification } from "NotificationContext";
import { formatterNumber } from "services/NumberConvertes";
import { Button } from "antd";
import { Link, useLocation } from "react-router-dom";
import { APP_PREFIX_PATH } from "configs/AppConfig";

const ErrorBanner = () => {
  const { unpaid } = useGetNotification();
  const location = useLocation();

  const isPrintPage = location.pathname.includes("/print/");

  if (isPrintPage) {
    return null;
  }

  if (!unpaid?.unpaid_total || unpaid?.unpaid_total === 0) {
    return null;
  }

  const buildFilterQuery = () => {
    if (!unpaid?.filter_query) return "";
    return Object.keys(unpaid.filter_query)
      .map(
        (key) =>
          encodeURIComponent(key) +
          "=" +
          encodeURIComponent(unpaid.filter_query[key]),
      )
      .join("&");
  };

  return (
    <div
      className="error-banner"
      style={{
        backgroundColor: "red",
        color: "white",
        padding: "10px 20px",
        textAlign: "center",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1005,
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        fontSize: "14px",
      }}
    >
      <div>
        Terdapat total{" "}
        {unpaid?.unpaid_total
          ? "Rp " + formatterNumber(unpaid.unpaid_total)
          : 0}{" "}
        Invoice belum lunas untuk Pembayar dengan ToP Cash. Silahkan lakukan
        penagihan.
      </div>
      <Link to={`${APP_PREFIX_PATH}/invoices?${buildFilterQuery()}`}>
        <Button
          type="primary"
          ghost
          size="small"
          style={{
            backgroundColor: "white",
            color: "red",
            border: "none",
            height: "30px",
            padding: "0 10px",
          }}
        >
          Lihat Data
        </Button>
      </Link>
    </div>
  );
};

export default ErrorBanner;
